
// /////////////////////////////////////////////
// UI
// /////////////////////////////////////////////

export function toggleContentOverlay ({ commit }) {
  commit('TOGGLE_CONTENT_OVERLAY')
}
  
export function updateTheme ({ commit }, val) {
  commit('UPDATE_THEME', val)
}
